import { useNavigate } from 'react-router-dom';
import { useUsuario } from '../../context/UsuarioContext';

// Lógica propia de la page Acceso: al confirmar el ID, lo guarda y
// redirige a Mis turnos. El estado del input vive en FormularioIdPaciente.
export function useAcceso() {
  const { setPacienteId } = useUsuario();
  const navigate = useNavigate();

  const confirmar = (id) => {
    setPacienteId(id);
    navigate('/mis-turnos');
  };

  return { confirmar };
}
